<h2 mat-dialog-title>Setup Answers</h2>


<mat-dialog-content class="mat-typography">

  <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
    <span style="font-size: 18px;">{{Question.Question}}</span>
    <span style="font-size: 15px;font-weight: 400;">{{Question.QuestionTypeName}}</span>

  </div>

  <div style="display: flex;flex-direction: column;">



    <mat-form-field class="DBSS" *ngIf="Question.QuestionTypeId == 1" style="width: 200px;align-self: center;">
      <mat-label>Select the correct Answer</mat-label>
      <mat-select  (selectionChange)="changeFTAnser($event.value)" [(ngModel)]="selectedTFAnswer">
        <mat-option [value]="-1">-select Answer</mat-option>
        <mat-option [value]="0">False</mat-option>
        <mat-option [value]="1">True</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="DBSS" *ngIf="Question.QuestionTypeId == 2">

      <div style="display: flex;flex-direction: row;    flex: 1;
      justify-content: space-between;">
        <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
          <span style="font-weight: bold;">Enter answer option</span>
        </div>
        <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
          <span style="font-weight: bold;">Select Correct</span>
        </div>
        <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
          <span> </span>
        </div>
      </div>

      <mat-list style="min-height: 20px;" role="list" *ngFor="let ans of MultipleChoiceTF">
        <mat-list-item role="listitem"><div style="display: flex;flex-direction: row;    flex: 1;
          justify-content: space-between;">
            <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <span style="font-weight: bold;">{{ans.QuestionName}}</span>
            </div>
            <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <span style="font-weight: bold;">
                <button mat-button (click)="AnswerCheckMC(ans)">
                <i class="material-icons alert__icon" style="color: green;" *ngIf="ans.correct==true">radio_button_checked</i>
                <i class="material-icons alert__icon" style="color: green;" *ngIf="ans.correct == false || ans.correct == null">radio_button_unchecked</i>
              </button>
              </span>
            </div>
            <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <button mat-button (click)="removeMCAnswer(ans)">
                <i class="material-icons alert__icon" style="color: red;">do_not_disturb_on</i>
              </button>
            </div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
          
      </mat-list>

      <div style="display: flex;flex-direction: row;align-items: center;">
        <mat-form-field style="display: flex;flex:1;min-width: 500px;">
          <mat-label>Answer</mat-label>
          <input style="min-width: 500px;" type="text" matInput placeholder="Answer" [(ngModel)]="AnswerName">
        </mat-form-field>
        <button mat-raised-button (click)="AddMultipleChoice()" [disabled]="AnswerName==''">
          <i class="material-icons alert__icon">add</i>
          <span>Add Answer</span>
        </button>
      </div>

    </div>

    <div style="display: flex;flex-direction: column;" *ngIf="Question.QuestionTypeId == 3">
      <div style="display: flex;flex-direction: row;justify-content: space-between;">
        <mat-label style="font-weight: bold;">Number of correct answers required</mat-label>
        <input style="min-width: 100px" type="number" matInput placeholder="0" [(ngModel)]="AnswerNumber">
      </div>
     
      <div style="display: flex;flex-direction: column;">
        <mat-card style="margin-top: 20px;margin-bottom: 20px;">
      <div style="display: flex;flex-direction: row;justify-content: space-between;min-height: 50px;background-color: whitesmoke;">
        <div style="display: flex;flex-direction: column;flex:1;align-items: center;
        justify-content: center;">
          <span style="font-weight: bold;">Enter Answer Option</span>
        </div>
        <div style="display: flex;flex-direction: column;flex:0.5;align-items: center;
        justify-content: center;">
          <span style="font-weight: bold;">Select Correct</span>
        </div>
        <div style="display: flex;flex-direction: column;flex:0.5;">
          <span> </span>
        </div>
      </div>

      <div style="display: flex;flex-direction: row;justify-content: center;align-items: center;" *ngIf="!MultipleSelection || MultipleSelection.length <=0">
        <span style="align-self: center;">---</span>
      </div>

      <mat-list style="min-height: 20px;" role="list" *ngFor="let ans of MultipleSelection">
        <mat-list-item role="listitem"><div style="display: flex;flex-direction: row;    flex: 1;
          justify-content: space-between;">
            <div style="flex:1;flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <span style="font-weight: bold;">{{ans.QuestionName}}</span>
            </div>
            <div style="flex:0.5;flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <span style="font-weight: bold;">
               
                <i class="material-icons button__icon" (click)="AnswerCheckMS(ans)" style="color: green;cursor: pointer;" *ngIf="ans.correct==true">check_box</i>
                <i class="material-icons button__icon" (click)="AnswerCheckMS(ans)" style="color: green;cursor: pointer;" *ngIf="ans.correct == false || ans.correct == null">check_box_outline_blank</i>
              
              </span>
            </div>
            <div style="flex:0.5;flex-direction: row;display: flex;align-items: center;justify-content: center;">
             
                <i (click)="removeMSAnswer(ans)" class="material-icons button__icon" style="color: red;cursor: pointer;">do_not_disturb_on</i>
            
            </div>
          </div>
          <mat-divider></mat-divider>
        </mat-list-item>
          
      </mat-list>

    </mat-card>
      <div style="display: flex;flex-direction: row;align-items: center;margin-top: 20px;">
        <div style="display: flex;flex:1;align-items: center;">
          <mat-label style="margin-right: 20px;
          font-size: 15px;">Answer</mat-label>
          <input style="min-width: 500px;" type="text" matInput placeholder="Answer" [(ngModel)]="AnswerNameMS">
        </div>
        <button style="align-self: center;" class="button button--primary" (click)="AddMultipleSelection()" [disabled]="AnswerNameMS==''">
          <i class="material-icons button__icon">add</i>
          <span  class="button__text">Add Answer</span>
        </button>
      </div>

      <div *ngIf="showError == true">
        <h2 style="color:red">Number of correct Answers must be more than or equal to {{AnswerNumber}}</h2>
      </div>
      
      </div>

    </div>





  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button (click)="DialogClose()">Cancel</button>
  <button mat-raised-button (click)="onSubmit()">Submit</button>
</mat-dialog-actions>
<!-- <div class="buttonbelow" style="align-self: flex-end;bottom:0px">
    <button mat-raised-button (click)="DialogClose()">Cancel</button>
    <button mat-raised-button (click)="onSubmit()">Submit</button>

  </div> -->